/**
 * Check if the second version string is greater than the first
 * @param {string} version1 - The first version string
 * @param {string} version2 - The second version string
 * @return {boolean} - Returns true if version2 is greater than version1, false otherwise
 */
function compareVersions(version1: string, version2: string): boolean {
    const version1Components = version1.split(".").map((x) => parseInt(x));
    const version2Components = version2.split(".").map((x) => parseInt(x));

    for (let i = 0; i < version1Components.length; i++) {
        if (version2Components.length === i) {
            return false;
        }

        if (version1Components[i] < version2Components[i]) {
            return true;
        } else if (version1Components[i] > version2Components[i]) {
            return false;
        }
    }

    return version1Components.length < version2Components.length;
}

export default compareVersions;
